export function loadGoogleAnalytics() {
  if (
    window.gtag ||
    document.querySelector('script[src*="googletagmanager.com/gtag"]')
  ) {
    return;
  }

  const gAnalytics = document.createElement("script");
  gAnalytics.src = "https://www.googletagmanager.com/gtag/js?id=G-ZZR8FFRCQ5";
  gAnalytics.async = true;
  document.head.appendChild(gAnalytics);

  gAnalytics.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag; // Make gtag globally available
    gtag("js", new Date());
    gtag("config", "G-ZZR8FFRCQ5");
    console.log("Google Analytics loaded");
  };

  gAnalytics.onerror = () => {
    console.error("Failed to load Google Analytics");
  };
}
